import { createApp } from 'vue'
import { registerSW } from 'virtual:pwa-register'
import App from './App.vue'
import { replaceNumber } from './replace-number.js'
import './styles.css'

registerSW({ immediate: true, onNeedRefresh() { window.dispatchEvent(new CustomEvent('zaocan-update-ready')) } })
createApp(App).directive('replace-number', replaceNumber).mount('#app')
